import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';

import { TopNavbarComponent } from '../../shared/top-navbar/top-navbar.component';
import { SideNavbarComponent } from '../../shared/side-navbar/side-navbar.component';
import { EditUserProfileComponent } from '../../authentication/edit-user-profile/edit-user-profile.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { MaintenanceBannerComponent } from '../../shared/notifications/maintenance-banner/maintenance-banner.component';

@Component({
  selector: 'app-app-layout',
  standalone: true,
  imports: [
    TopNavbarComponent,
    SideNavbarComponent,
    EditUserProfileComponent,
    FooterComponent,
    MaintenanceBannerComponent,
    Toast,
    RouterOutlet,
  ],
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.css'],
  host: { class: 'app-layout-host' },
})
export class AppLayoutComponent {}
